'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _example1Txt = require('./example1.txt');

var _example1Txt2 = _interopRequireDefault(_example1Txt);

var _example2Txt = require('./example2.txt');

var _example2Txt2 = _interopRequireDefault(_example2Txt);

var PlayerPage = (function (_React$Component) {
    _inherits(PlayerPage, _React$Component);

    function PlayerPage() {
        _classCallCheck(this, PlayerPage);

        _get(Object.getPrototypeOf(PlayerPage.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(PlayerPage, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(
                'div',
                { className: 'container' },
                _react2['default'].createElement(
                    'p',
                    null,
                    'This is a page explaining how to use the React VR Player'
                ),
                _react2['default'].createElement(
                    'h3',
                    { className: 'header' },
                    'Welcome to the VR Player Demo Page'
                ),
                _react2['default'].createElement('img', { src: 'https://img.shields.io/github/issues/antoinejaussoin/react-vr-player.svg' }),
                _react2['default'].createElement(
                    'h4',
                    null,
                    'Demo'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'The demo is on a separate page, since this is a fullscreen component. You can run the demo by clicking here:'
                ),
                _react2['default'].createElement(
                    _reactRouter.Link,
                    { to: '/react-vr-player-demo', className: 'waves-effect waves-light btn' },
                    _react2['default'].createElement(
                        'i',
                        { className: 'material-icons left' },
                        'play_arrow'
                    ),
                    'Run the demo'
                ),
                _react2['default'].createElement(
                    'h4',
                    null,
                    'How to Use'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'The component is pretty easy to use: build an array of video sources, and you should be good to go:'
                ),
                _react2['default'].createElement(
                    'pre',
                    null,
                    _react2['default'].createElement(
                        'code',
                        { className: 'javascript' },
                        _example1Txt2['default']
                    )
                ),
                _react2['default'].createElement(
                    'h4',
                    null,
                    'Options'
                ),
                _react2['default'].createElement(
                    'h5',
                    null,
                    'Brand'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'You can specify a brand name (displayed in bold in the control bar) using the \'brand\' props.'
                ),
                _react2['default'].createElement(
                    'h5',
                    null,
                    'Title'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'You can display a title (presumably the video\'s title) using the \'title\' props.'
                ),
                _react2['default'].createElement(
                    'h5',
                    null,
                    'Keys Mapping'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'The player can also be controlled using the keyboard. You can remap the keys if you are not on a QWERTY keyboard.'
                ),
                _react2['default'].createElement(
                    'h5',
                    null,
                    'Full example: '
                ),
                _react2['default'].createElement(
                    'pre',
                    null,
                    _react2['default'].createElement(
                        'code',
                        { className: 'javascript' },
                        _example2Txt2['default']
                    )
                )
            );
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            $('pre code').each(function (i, block) {
                hljs.highlightBlock(block);
            });
        }
    }]);

    return PlayerPage;
})(_react2['default'].Component);

exports['default'] = PlayerPage;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./~/babel-loader!./source/vr-player/Player.jsx
 **/